import script from "./CommonBreadcrumb.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonBreadcrumb.vue?vue&type=script&lang=ts&setup=true"

import "./CommonBreadcrumb.vue?vue&type=style&index=0&id=19c675f6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c675f6"]])

export default __exports__